module.exports = __webpack_public_path__ + "static/media/preloader.06f7cbaf.svg";